import axios from "axios";
import { useState, useCallback } from "react";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";

const fetchSearch = async (params) => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  const user = JSON.parse(userDetails);

  const response = await axios.get(`${API_BASE_PATH}${API_BASE_RELATIVE_PATH}`, {
    params: {
      action: "searchInAllSuite",
      companyid: user.companyid,
      ...params,
    },
  });

  const data = response.data;
  if (Array.isArray(data) && Array.isArray(data?.[0])) {
    return data.flat();
  }
  return data;
};

const useSearchSuiteQuery = () => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const refetchWithParams = useCallback(async (paramsData) => {
    setIsLoading(true);
    setError(null);
    try {
      const result = await fetchSearch(paramsData);
      setData(result);
      return result;
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setIsLoading(false);
    }
  }, []);

  return {
    data,
    isLoading,
    error,
    refetchWithParams,
  };
};

export default useSearchSuiteQuery;
